/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageDto } from '../../models/image-dto';
import { ImageShowResponse } from '../../models/image-show-response';

export interface PostImageCreate$Params {
      body: ImageDto
}

export function postImageCreate(http: HttpClient, rootUrl: string, params: PostImageCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postImageCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImageShowResponse>;
    })
  );
}

postImageCreate.PATH = '/v1/image';
